import { render, staticRenderFns } from "./youtubeVideos.vue?vue&type=template&id=fb567a0e&scoped=true&"
import script from "./youtubeVideos.vue?vue&type=script&lang=js&"
export * from "./youtubeVideos.vue?vue&type=script&lang=js&"
import style0 from "./youtubeVideos.vue?vue&type=style&index=0&id=fb567a0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb567a0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDialog,VRow})
